import { createReducer } from 'redux-create-reducer';
import callAPI from '../../../utils/callAPI';
import { WalletName, WalletNameDisplay } from '../../../constant/wallet';
import { FilterPointManagementType } from '../../../constant/profile';
import { getCurrentMonth, getCurrentYear } from '../../../utils/date';
// GET Profile
export const REQUEST_PROFILE = 'REQUEST_PROFILE';
export const REQUEST_PROFILE_SUCCESS = 'REQUEST_PROFILE_SUCCESS';
export const REQUEST_PROFILE_FAILURE = 'REQUEST_PROFILE_FAILURE';
export const ACTION_REQUEST_PROFILE = 'ACTION_REQUEST_PROFILE';

// Update Profile
export const REQUEST_UPDATE_PROFILE = 'REQUEST_UPDATE_PROFILE';
export const REQUEST_UPDATE_PROFILE_SUCCESS = 'REQUEST_UPDATE_PROFILE_SUCCESS';
export const REQUEST_UPDATE_PROFILE_FAILURE = 'REQUEST_UPDATE_PROFILE_FAILURE';
export const ACTION_UPDATE_PROFILE = 'ACTION_UPDATE_PROFILE';

// CHANGE password
export const REQUEST_CHANGE_PASSWORD = 'REQUEST_CHANGE_PASSWORD';
export const REQUEST_CHANGE_PASSWORD_SUCCESS = 'REQUEST_CHANGE_PASSWORD_SUCCESS';
export const REQUEST_CHANGE_PASSWORD_FAILURE = 'REQUEST_CHANGE_PASSWORD_FAILURE';
export const ACTION_CHANGE_PASSWORD = 'ACTION_CHANGE_PASSWORD';

// POST update email
export const REQUEST_UPDATE_EMAIL = 'REQUEST_UPDATE_EMAIL';
export const REQUEST_UPDATE_EMAIL_SUCCESS = 'REQUEST_UPDATE_EMAIL_SUCCESS';
export const REQUEST_UPDATE_EMAIL_FAILURE = 'REQUEST_UPDATE_EMAIL_FAILURE';
export const ACTION_UPDATE_EMAIL = 'ACTION_UPDATE_EMAIL';

// POST verify email
export const REQUEST_VERIFY_EMAIL = 'REQUEST_VERIFY_EMAIL';
export const REQUEST_VERIFY_EMAIL_SUCCESS = 'REQUEST_VERIFY_EMAIL_SUCCESS';
export const REQUEST_VERIFY_EMAIL_FAILURE = 'REQUEST_VERIFY_EMAIL_FAILURE';
export const ACTION_VERIFY_EMAIL = 'ACTION_VERIFY_EMAIL';

// DELETE action
export const REQUEST_DELETE_ACCOUNT = 'REQUEST_DELETE_ACCOUNT';
export const REQUEST_DELETE_ACCOUNT_SUCCESS = 'REQUEST_DELETE_ACCOUNT_SUCCESS';
export const REQUEST_DELETE_ACCOUNT_FAILURE = 'REQUEST_DELETE_ACCOUNT_FAILURE';
export const ACTION_DELETE_ACCOUNT = 'ACTION_DELETE_ACCOUNT';

// Post sync
export const REQUEST_SYNC_ACCOUNT = 'REQUEST_SYNC_ACCOUNT';
export const REQUEST_SYNC_ACCOUNT_SUCCESS = 'REQUEST_SYNC_ACCOUNT_SUCCESS';
export const REQUEST_SYNC_ACCOUNT_FAILURE = 'REQUEST_SYNC_ACCOUNT_FAILURE';
export const ACTION_SYNC_ACCOUNT = 'ACTION_SYNC_ACCOUNT';

// Connect wallet
export const ACTION_CONNECT = 'ACTION_CONNECT';
export const REQUEST_CONNECT_WALLET = 'REQUEST_CONNECT_WALLET';
export const REQUEST_CONNECT_WALLET_SUCCESS = 'REQUEST_CONNECT_WALLET_SUCCESS';
export const REQUEST_CONNECT_WALLET_FAILURE = 'REQUEST_CONNECT_WALLET_FAILURE';

// Connect Xaman
export const ACTION_CONNECT_XAMAN = 'ACTION_CONNECT_XAMAN';
export const REQUEST_CONNECT_XAMAN_WALLET = 'REQUEST_CONNECT_XAMAN_WALLET';
export const REQUEST_CONNECT_XAMAN_WALLET_SUCCESS = 'REQUEST_CONNECT_XAMAN_WALLET_SUCCESS';
export const REQUEST_CONNECT_XAMAN_WALLET_FAILURE = 'REQUEST_CONNECT_XAMAN_WALLET_FAILURE';

// disConnect wallet
export const ACTION_DISCONNECT = 'ACTION_DISCONNECT';
export const REQUEST_DISCONNECT_WALLET = 'REQUEST_DISCONNECT_WALLET';
export const REQUEST_DISCONNECT_WALLET_SUCCESS = 'REQUEST_DISCONNECT_WALLET_SUCCESS';
export const REQUEST_DISCONNECT_WALLET_FAILURE = 'REQUEST_DISCONNECT_WALLET_FAILURE';

// Fetch wallet
export const ACTION_FETCH_WALLETS = 'ACTION_FETCH_WALLETS';
export const REQUEST_FETCH_WALLET = 'REQUEST_FETCH_WALLET';
export const REQUEST_FETCH_WALLET_SUCCESS = 'REQUEST_FETCH_WALLET_SUCCESS';
export const REQUEST_FETCH_WALLET_FAILURE = 'REQUEST_FETCH_WALLET_FAILURE';

// Point Management
export const UPDATE_POINT_HISTORY_FILTER = 'UPDATE_POINT_HISTORY_FILTER';
export const ACTION_FETCH_POINT_HISTORY = 'ACTION_FETCH_POINT_HISTORY';
export const REQUEST_POINT_HISTORY = 'REQUEST_POINT_HISTORY';
export const REQUEST_POINT_HISTORY_SUCCESS = 'REQUEST_POINT_HISTORY_SUCCESS';
export const REQUEST_POINT_HISTORY_FAILURE = 'REQUEST_POINT_HISTORY_FAILURE';

// leaderboard
export const ACTION_FETCH_LEADERBOARD = 'ACTION_FETCH_LEADERBOARD';
export const UPDATE_LEADERBOARD_FILTER = 'UPDATE_LEADERBOARD_FILTER';
export const REQUEST_LEADERBOARD = 'REQUEST_LEADERBOARD';
export const REQUEST_LEADERBOARD_SUCCESS = 'REQUEST_LEADERBOARD_SUCCESS';
export const REQUEST_LEADERBOARD_FAILURE = 'REQUEST_LEADERBOARD_FAILURE';

// Trust line
export const UPDATE_TRUST_LINE = 'UPDATE_TRUST_LINE';
export const ACTION_GET_TRUST_LINE = 'ACTION_GET_TRUST_LINE';
export const REQUEST_GET_TRUST_LINE = 'REQUEST_GET_TRUST_LINE';
export const REQUEST_GET_TRUST_LINE_SUCCESS = 'REQUEST_GET_TRUST_LINE_SUCCESS';
export const REQUEST_GET_TRUST_LINE_FAILURE = 'REQUEST_GET_TRUST_LINE_FAILURE';

// Create Trust Line
export const ACTION_CREATE_TRUST_LINE = 'ACTION_CREATE_TRUST_LINE';
export const REQUEST_CREATE_TRUST_LINE = 'REQUEST_CREATE_TRUST_LINE';
export const REQUEST_CREATE_TRUST_LINE_SUCCESS = 'REQUEST_CREATE_TRUST_LINE_SUCCESS';
export const REQUEST_CREATE_TRUST_LINE_FAILURE = 'REQUEST_CREATE_TRUST_LINE_FAILURE';

const defaultState = {
  // GET Profile
  profile: {},
  profileError: {},
  fetchingProfile: false,
  failedFetchingProfile: false,

  // UPDATE Profile
  updatedProfileError: {},
  updatedProfile: {},
  isRequestingUpdateProfile: false,
  isUpdateProfileSuccess: false,
  isUpdateProfileFailure: false,

  // CHANGE password
  changedPassword: {},
  changedPasswordError: null,
  isRequestingChangePassword: false,
  isChangePasswordSuccess: false,
  isChangePasswordFailure: false,

  // UPDATE email
  updatedEmail: {},
  updatedEmailError: {},
  isRequestingUpdateEmail: false,
  isUpdateEmailSuccess: false,
  isUpdateEmailFailure: false,

  // Verify email
  verifiedEmail: {},
  verifiedEmailError: {},
  isRequestingVerifyEmail: false,
  isVerifyEmailSuccess: false,
  isVerifyEmailFailure: false,

  // Delete account
  deletedAccount: {},
  deletedAccountError: {},
  isRequestingDeleteAccount: false,
  isDeleteAccountSuccess: false,
  isDeleteAccountFailure: false,

  // Sync account
  syncedAccount: {},
  syncedAccountError: {},
  isRequestingSyncAccount: false,
  isSyncAccountSuccess: false,
  isSyncAccountFailure: false,

  // Connect wallet
  isConnectingWallet: false,
  isConnectWalletSuccess: false,
  isConnectWalletFailure: false,

  // Connect Xaman wallet
  isConnectingXamanWallet: false,
  isConnectXamanWalletSuccess: false,
  isConnectXamanWalletFailure: false,

  // get wallet
  wallets: [
    { provider: WalletNameDisplay[WalletName.PHANTOM], walletAddress: '', isDefault: false },
    { provider: WalletNameDisplay[WalletName.METAMASK], walletAddress: '', isDefault: false },
    { provider: WalletNameDisplay[WalletName.XAMAN], walletAddress: '', isDefault: false },
  ],
  isFetchingWallet: false,
  isFetchWalletSuccess: false,
  isFetchWalletFailure: false,

  // leaderboard
  leaderboardFilter: {
    countryId: null,
    month: getCurrentMonth()?.toString(),
    year: getCurrentYear()?.toString(),
  },

  leaderboardData: {
    total: 0,
    items: [],
    currentUser: null,
  },

  isFetchingLeaderboard: false,
  isFetchLeaderboardSuccess: false,
  isFetchLeaderboardFailure: false,

  // point management
  pointHistoryFilter: {
    filterType: FilterPointManagementType.MONTHLY,
  },

  pointHistory: {
    balanceData: [],
    earnData: [],
    spendData: [],
  },

  isFetchingPointHistory: false,
  isFetchPointHistorySuccess: false,
  isFetchPointHistoryFailure: false,

  // get trustLine xaman wallet
  trustLineWallets: [],
  isFetchingTrustLineWallet: false,
  isFetchTrustLineWalletSuccess: false,
  isFetchTrustLineWalletFailure: false,

  // create trustline
  creatingTrustLineWallet: false,
  createTrustLineWalletSuccess: false,
  createTrustLineWalletFailure: false,
};

const reducer = createReducer(defaultState, {
  // GET profile
  [REQUEST_PROFILE]: (state, _action) => ({
    ...state,
    fetchingProfile: true,
    failedFetchingProfile: false,
  }),
  [REQUEST_PROFILE_SUCCESS]: (state, action) => ({
    ...state,
    profile: action.payload.data,
    fetchingProfile: false,
    failedFetchingProfile: false,
  }),
  [REQUEST_PROFILE_FAILURE]: (state, action) => ({
    ...state,
    profileError: action.payload,
    fetchingProfile: false,
    failedFetchingProfile: true,
  }),

  // UPDATE profile
  [ACTION_UPDATE_PROFILE]: (state, _action) => ({
    ...state,
    isRequestingUpdateProfile: true,
  }),
  [REQUEST_UPDATE_PROFILE_SUCCESS]: (state, action) => ({
    ...state,
    updatedProfiles: action.payload,
    isRequestingUpdateProfile: false,
    isUpdateProfileFailure: false,
    isUpdateProfileSuccess: true,
  }),
  [REQUEST_UPDATE_PROFILE_FAILURE]: (state, action) => ({
    ...state,
    updatedProfileError: action.payload,
    isRequestingUpdateProfile: false,
    isUpdateProfileFailure: true,
    isUpdateProfileSuccess: false,
  }),

  // CHANGE password
  [REQUEST_CHANGE_PASSWORD]: (state, _action) => ({
    ...state,
    changedPasswordError: null,
    isRequestingChangePassword: true,
  }),
  [REQUEST_CHANGE_PASSWORD_SUCCESS]: (state, action) => ({
    ...state,
    changedPassword: action.payload,
    isRequestingChangePassword: false,
    isChangePasswordFailure: false,
    isChangePasswordSuccess: true,
  }),
  [REQUEST_CHANGE_PASSWORD_FAILURE]: (state, action) => ({
    ...state,
    changedPasswordError: action.payload, //.data?.message[0]?.error
    isRequestingChangePassword: false,
    isChangePasswordFailure: true,
    isChangePasswordSuccess: false,
  }),

  // UPDATE email
  [REQUEST_UPDATE_EMAIL]: (state, _action) => ({
    ...state,
    isRequestingUpdateEmail: true,
  }),
  [REQUEST_UPDATE_EMAIL_SUCCESS]: (state, action) => ({
    ...state,
    updatedEmail: action.payload,
    isRequestingUpdateEmail: false,
    isUpdateEmailSuccess: true,
    isUpdateEmailFailure: false,
  }),
  [REQUEST_UPDATE_EMAIL_FAILURE]: (state, action) => ({
    ...state,
    updatedEmailError: action.payload,
    isRequestingUpdateEmail: false,
    isUpdateEmailSuccess: false,
    isUpdateEmailFailure: true,
  }),

  // Verify Email
  [REQUEST_VERIFY_EMAIL]: (state, _action) => ({
    ...state,
    isRequestingVerifyEmail: true,
  }),
  [REQUEST_VERIFY_EMAIL_SUCCESS]: (state, action) => ({
    ...state,
    verifiedEmail: action.payload,
    isRequestingVerifyEmail: false,
    isVerifyEmailFailure: false,
    isVerifyEmailSuccess: true,
  }),
  [REQUEST_VERIFY_EMAIL_FAILURE]: (state, action) => ({
    ...state,
    verifiedEmailError: action.payload,
    isRequestingVerifyEmail: false,
    isVerifyEmailFailure: true,
    isVerifyEmailSuccess: false,
  }),

  // Delete account
  [REQUEST_DELETE_ACCOUNT]: (state, _action) => ({
    ...state,
    isRequestingDeleteAccount: true,
  }),
  [REQUEST_DELETE_ACCOUNT_SUCCESS]: (state, action) => ({
    ...state,
    deletedAccount: action.payload,
    isRequestingDeleteAccount: false,
    isDeleteAccountFailure: false,
    isDeleteAccountSuccess: true,
  }),
  [REQUEST_DELETE_ACCOUNT_SUCCESS]: (state, action) => ({
    ...state,
    deletedAccountError: action.payload,
    isRequestingDeleteAccount: false,
    isDeleteAccountFailure: false,
    isDeleteAccountSuccess: true,
  }),

  // POST sync
  [REQUEST_SYNC_ACCOUNT]: (state, _action) => ({
    ...state,
    isRequestingSyncAccount: true,
  }),
  [REQUEST_SYNC_ACCOUNT_SUCCESS]: (state, action) => ({
    ...state,
    syncedAccount: action.payload,
    isRequestingSyncAccount: false,
    isSyncAccountSuccess: true,
    isSyncAccountFailure: false,
  }),
  [REQUEST_SYNC_ACCOUNT_FAILURE]: (state, action) => ({
    ...state,
    syncedAccountError: action.payload,
    isRequestingSyncAccount: false,
    isSyncAccountSuccess: false,
    isSyncAccountFailure: true,
  }),

  // connect wallet
  [REQUEST_CONNECT_WALLET]: (state, _action) => ({
    ...state,
    isConnectingWallet: true,
    isConnectWalletSuccess: false,
    isConnectWalletFailure: false,
  }),
  [REQUEST_CONNECT_WALLET_SUCCESS]: (state) => ({
    ...state,
    isConnectingWallet: false,
    isConnectWalletSuccess: true,
    isConnectWalletFailure: false,
  }),
  [REQUEST_CONNECT_WALLET_FAILURE]: (state) => ({
    ...state,
    isConnectingWallet: false,
    isConnectWalletSuccess: false,
    isConnectWalletFailure: true,
  }),

  // connect xaman wallet
  [REQUEST_CONNECT_XAMAN_WALLET]: (state, _action) => ({
    ...state,
    isConnectingXamanWallet: true,
    isConnectXamanWalletSuccess: false,
    isConnectXamanWalletFailure: false,
  }),
  [REQUEST_CONNECT_XAMAN_WALLET_SUCCESS]: (state) => ({
    ...state,
    isConnectingXamanWallet: false,
    isConnectXamanWalletSuccess: true,
    isConnectXamanWalletFailure: false,
  }),
  [REQUEST_CONNECT_XAMAN_WALLET_FAILURE]: (state) => ({
    ...state,
    isConnectingXamanWallet: false,
    isConnectXamanWalletSuccess: false,
    isConnectXamanWalletFailure: true,
  }),

  // get wallets
  [REQUEST_FETCH_WALLET]: (state, _action) => ({
    ...state,
    isFetchingWallet: true,
    isFetchWalletSuccess: false,
    isFetchWalletFailure: false,
  }),
  [REQUEST_FETCH_WALLET_SUCCESS]: (state, action) => ({
    ...state,
    wallets: action?.payload?.data || [
      { provider: WalletNameDisplay[WalletName.PHANTOM], walletAddress: '', isDefault: false },
      { provider: WalletNameDisplay[WalletName.METAMASK], walletAddress: '', isDefault: false },
      { provider: WalletNameDisplay[WalletName.XAMAN], walletAddress: '', isDefault: false },
    ],
    isFetchingWallet: false,
    isFetchWalletSuccess: true,
    isFetchWalletFailure: false,
  }),
  [REQUEST_FETCH_WALLET_FAILURE]: (state) => ({
    ...state,
    isFetchingWallet: false,
    isFetchWalletSuccess: false,
    isFetchWalletFailure: true,
  }),

  // point management
  [UPDATE_POINT_HISTORY_FILTER]: (state, _action) => ({
    ...state,
    pointHistoryFilter: _action.payload,
  }),
  [REQUEST_POINT_HISTORY]: (state, _action) => ({
    ...state,
    isFetchingPointHistory: true,
    isFetchPointHistorySuccess: false,
    isFetchPointHistoryFailure: false,
  }),
  [REQUEST_POINT_HISTORY_SUCCESS]: (state, action) => ({
    ...state,
    pointHistory: action?.payload?.data,
    isFetchingPointHistory: false,
    isFetchPointHistorySuccess: true,
    isFetchPointHistoryFailure: false,
  }),
  [REQUEST_POINT_HISTORY_FAILURE]: (state) => ({
    ...state,
    isFetchingPointHistory: false,
    isFetchPointHistorySuccess: false,
    isFetchPointHistoryFailure: true,
  }),

  // leaderboard
  [UPDATE_LEADERBOARD_FILTER]: (state, _action) => ({
    ...state,
    leaderboardFilter: _action.payload,
  }),
  [REQUEST_LEADERBOARD]: (state, _action) => ({
    ...state,
    isFetchingLeaderboard: true,
    isFetchLeaderboardSuccess: false,
    isFetchLeaderboardFailure: false,
  }),
  [REQUEST_LEADERBOARD_SUCCESS]: (state, action) => ({
    ...state,
    leaderboardData: action?.payload?.data || {
      total: 0,
      items: [],
      currentUser: null,
    },
    isFetchingLeaderboard: false,
    isFetchLeaderboardSuccess: true,
    isFetchLeaderboardFailure: false,
  }),
  [REQUEST_LEADERBOARD_FAILURE]: (state) => ({
    ...state,
    leaderboardData: {
      total: 0,
      items: [],
      currentUser: null,
    },
    isFetchingLeaderboard: false,
    isFetchLeaderboardSuccess: false,
    isFetchLeaderboardFailure: true,
  }),

  // Trust line
  [UPDATE_TRUST_LINE]: (state, _action) => ({
    ...state,
    trustLineWallets: _action.payload,
  }),
  [REQUEST_GET_TRUST_LINE]: (state, _action) => ({
    ...state,
    isFetchingTrustLineWallet: true,
    isFetchTrustLineWalletSuccess: false,
    isFetchTrustLineWalletFailure: false,
  }),
  [REQUEST_GET_TRUST_LINE_SUCCESS]: (state, action) => ({
    ...state,
    trustLineWallets: action?.payload?.data,
    isFetchingTrustLineWallet: false,
    isFetchTrustLineWalletSuccess: true,
    isFetchTrustLineWalletFailure: false,
  }),
  [REQUEST_GET_TRUST_LINE_FAILURE]: (state) => ({
    ...state,
    isFetchingTrustLineWallet: false,
    isFetchTrustLineWalletSuccess: false,
    isFetchTrustLineWalletFailure: true,
  }),

  // create trust line
  [REQUEST_CREATE_TRUST_LINE]: (state, _action) => ({
    ...state,
    creatingTrustLineWallet: true,
    createTrustLineWalletSuccess: false,
    createTrustLineWalletFailure: false,
  }),
  [REQUEST_CREATE_TRUST_LINE_SUCCESS]: (state) => ({
    ...state,
    creatingTrustLineWallet: false,
    createTrustLineWalletSuccess: true,
    createTrustLineWalletFailure: false,
  }),
  [REQUEST_CREATE_TRUST_LINE_FAILURE]: (state) => ({
    ...state,
    creatingTrustLineWallet: false,
    createTrustLineWalletSuccess: false,
    createTrustLineWalletFailure: true,
  }),
});

export default reducer;
export const namespace = 'profile';

export const actionGetProfile = () => ({
  type: ACTION_REQUEST_PROFILE,
});

export const actionUpdateProfile = (payload) => ({
  type: ACTION_UPDATE_PROFILE,
  payload: payload,
});

export const actionChangePassword = (payload) => ({
  type: ACTION_CHANGE_PASSWORD,
  payload: payload,
});

export const actionUpdateEmail = (newEmail) => ({
  type: ACTION_UPDATE_EMAIL,
  payload: newEmail,
});

export const actionVerifyEmail = (verifiedEmail) => ({
  type: ACTION_VERIFY_EMAIL,
  payload: verifiedEmail,
});

export const actionDeleteAccount = () => ({
  type: ACTION_DELETE_ACCOUNT,
});

export const actionSyncAccount = (syncAccount) => ({
  type: ACTION_SYNC_ACCOUNT,
  payload: syncAccount,
});

export const getProfilesAPI = (profileData) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: '/users/profile',
    actionTypes: [REQUEST_PROFILE, REQUEST_PROFILE_SUCCESS, REQUEST_PROFILE_FAILURE],
    variables: {
      ...profileData,
    },
    dispatch,
    getState,
  });
};

export const updateProfileAPI = (profileData) => async (dispatch, getState) => {
  return await callAPI({
    method: 'put',
    apiPath: '/users/update-profile',
    actionTypes: [
      REQUEST_UPDATE_PROFILE,
      REQUEST_UPDATE_PROFILE_SUCCESS,
      REQUEST_UPDATE_PROFILE_FAILURE,
    ],
    variables: {
      ...profileData,
    },
    dispatch,
    getState,
  });
};

export const changePasswordAPI = (newPassword) => async (dispatch, getState) => {
  return await callAPI({
    method: 'put',
    apiPath: '/users/change-password',
    actionTypes: [
      REQUEST_CHANGE_PASSWORD,
      REQUEST_CHANGE_PASSWORD_SUCCESS,
      REQUEST_CHANGE_PASSWORD_FAILURE,
    ],
    variables: {
      ...newPassword,
    },
    dispatch,
    getState,
  });
};

export const updateEmailAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/users/update-email',
    actionTypes: [REQUEST_UPDATE_EMAIL, REQUEST_UPDATE_EMAIL_SUCCESS, REQUEST_UPDATE_EMAIL_FAILURE],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

export const verifyEmailAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/users/verify-email',
    actionTypes: [REQUEST_VERIFY_EMAIL, REQUEST_VERIFY_EMAIL_SUCCESS, REQUEST_VERIFY_EMAIL_FAILURE],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

export const deleteAccountAPI = (userId) => async (dispatch, getState) => {
  return await callAPI({
    method: 'delete',
    apiPath: '/users/delete-account',
    actionTypes: [
      REQUEST_DELETE_ACCOUNT,
      REQUEST_DELETE_ACCOUNT_SUCCESS,
      REQUEST_DELETE_ACCOUNT_FAILURE,
    ],
    variables: {
      ...userId,
    },
    dispatch,
    getState,
  });
};

export const syncAccountAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/users/sync',
    actionTypes: [REQUEST_SYNC_ACCOUNT, REQUEST_SYNC_ACCOUNT_SUCCESS, REQUEST_SYNC_ACCOUNT_FAILURE],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

export const actionConnectWallet = (payload) => ({
  type: ACTION_CONNECT,
  payload,
});

export const connectWalletAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/wallets/extension/connect',
    actionTypes: [
      REQUEST_CONNECT_WALLET,
      REQUEST_CONNECT_WALLET_SUCCESS,
      REQUEST_CONNECT_WALLET_FAILURE,
    ],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

// Xaman

export const actionConnectXamanWallet = (payload) => ({
  type: ACTION_CONNECT_XAMAN,
  payload,
});

export const connectWalletXamanAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: 'xaman/connect',
    actionTypes: [
      REQUEST_CONNECT_XAMAN_WALLET,
      REQUEST_CONNECT_XAMAN_WALLET_SUCCESS,
      REQUEST_CONNECT_XAMAN_WALLET_FAILURE,
    ],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

export const actionFetchWallet = (payload) => ({
  type: ACTION_FETCH_WALLETS,
  payload,
});

export const fetchWalletAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: '/wallets/default',
    actionTypes: [REQUEST_FETCH_WALLET, REQUEST_FETCH_WALLET_SUCCESS, REQUEST_FETCH_WALLET_FAILURE],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

export const updateLeaderboardFilter = (payload) => ({
  type: UPDATE_LEADERBOARD_FILTER,
  payload,
});

export const actionFetchLeaderboard = (payload) => ({
  type: ACTION_FETCH_LEADERBOARD,
  payload,
});



export const fetchLeaderboardAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: '/leaderboard',
    actionTypes: [REQUEST_LEADERBOARD, REQUEST_LEADERBOARD_SUCCESS, REQUEST_LEADERBOARD_FAILURE],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

// point history

export const updatePointHistoryFilter = (payload) => ({
  type: UPDATE_POINT_HISTORY_FILTER,
  payload,
});

export const actionFetchPointHistory = (payload) => ({
  type: ACTION_FETCH_POINT_HISTORY,
  payload,
});

export const fetchPointHistoryAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: '/leaderboard/chart',
    actionTypes: [
      REQUEST_POINT_HISTORY,
      REQUEST_POINT_HISTORY_SUCCESS,
      REQUEST_POINT_HISTORY_FAILURE,
    ],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

// disconnect wallet

export const actionDisconnectWallet = (payload) => ({
  type: ACTION_DISCONNECT,
  payload,
});

export const disconnectWalletAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/wallets/extension/disconnect',
    actionTypes: [
      REQUEST_DISCONNECT_WALLET,
      REQUEST_DISCONNECT_WALLET_SUCCESS,
      REQUEST_DISCONNECT_WALLET_FAILURE,
    ],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

// trustLine

export const updateTrustLines = (payload) => ({
  type: UPDATE_TRUST_LINE,
  payload,
});

export const actionGetTrustLine = (payload) => ({
  type: ACTION_GET_TRUST_LINE,
  payload,
});

export const getTrustLineAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: 'xaman/trustLine',
    actionTypes: [
      REQUEST_GET_TRUST_LINE,
      REQUEST_GET_TRUST_LINE_SUCCESS,
      REQUEST_GET_TRUST_LINE_FAILURE,
    ],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

export const actionCreateTrustLine = (payload) => ({
  type: ACTION_CREATE_TRUST_LINE,
  payload,
});

export const createTrustLineAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: 'xaman/trustLine/create',
    actionTypes: [
      REQUEST_CREATE_TRUST_LINE,
      REQUEST_CREATE_TRUST_LINE_SUCCESS,
      REQUEST_CREATE_TRUST_LINE_FAILURE,
    ],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};
